import React from "react";
import Home from "./homeWrapper/Home";
import AntSpin from "../common/AntSpin";

export default function HomeWrapper({history, GET_DASHBOARD, data, user}){
    let props = {
        history,
        GET_DASHBOARD,
        data
    };
  
    if(!user.profile_info) return <AntSpin/>
    else return <Home props={props} profile={user.profile_info[0].label}/>
}


// WEBPACK FOOTER //
// ./src/components/general/HomeWrapper.jsx